import request from '@/utils/request'
import type { ApiResponse ,QueryParams, RuleForm} from '@/types/notice'


// 新增标准
export function addNotice(data: {
  content: string      // 必填
  name: string       // 必填
  beginTime: string  // YYYY-MM-DD HH:mm:ss
  endTime: string  // YYYY-MM-DD HH:mm:ss
  image: string;       // 图片，必填
}) {
  return request<ApiResponse>({
    url: '/admin/announcement',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

  export function listNoticeByPage(query: QueryParams) {
    return request({
      url: '/admin/announcement',
      method: 'get',
      params: { // 使用 params 而不是 query
        page: query.page,
        pageSize: query.pageSize
      }
    })
  }


  // 删除标准
  export function deleteNotice(id: string) {
    return request({
      url: '/admin/announcement/' + id,
      method: 'delete'
    })
  }
  // 更新标准 - 修改函数签名，分别接收 id 和数据
export function updateNotice(data: any,id:string) {
  return request({
    url: `/admin/announcement/` + id, // 使用模板字符串正确拼接 id
    method: 'put',
    data
  })
}


  // 批量删除标准
  export function deleteNoticeBatch(ids: string[]) {
    return request({
      url: `/admin/announcement/batch/${ids.join(',')}`, // 将数组转换为逗号分隔的字符串
      method: 'delete'
    })
  }

